/* eslint-disable class-methods-use-this */

import $ from 'jquery';
import moment from 'moment';
// import 'moment/min/locales'; // TODO very heavy, try to replace with server strings
import 'eonasdan-bootstrap-datetimepicker';
import tippy from 'tippy.js';
import { ajaxSettings } from '../common/helpers';
import Validator from '../common/Validator';
import ajaxDefault from '../imports/ajaxDefaults';
import cartDropdown from '../imports/cartDropdown';
import cartToggle from '../imports/cartToggle';
import Location from '../imports/Location';
import Courier from '../imports/Courier';
import Office from '../imports/Office';
import itemsSummary from '../imports/itemsSummary';

const { Base } = window.returns.default;

/**
 * Shipping default page class
 */
class Shipping extends Base {
  /**
   * Main functionality of the page
   */
  init() {
    tippy('.courier__tooltip');

    const validatorOptions = this.options.validator || {};

    this.validator = new Validator(validatorOptions);
    ajaxDefault();

    itemsSummary();

    const $html = $('html');
    const direction = $html.attr('dir');

    cartDropdown();
    let cartQuantity = 0;
    $('.cart__product[data-quantity]').each((index, element) => {
      cartQuantity += Number.parseInt($(element).data('quantity'), 10);
    });
    cartToggle.set(cartQuantity);

    $.fn.datetimepicker.defaults = {
      ...$.fn.datetimepicker.defaults,
      ...{
        widgetPositioning: {
          horizontal: (direction === 'ltr') ? 'left' : 'right',
          vertical: 'bottom',
        },
        locale: $html.attr('lang'),
        focusOnShow: true,
        ignoreReadonly: true,
        icons: {
          time: 'icon icon_clock',
          date: 'icon icon_calendar',
          up: 'icon icon_chevron-up',
          down: 'icon icon_chevron-down',
          previous: 'icon icon_chevron-left',
          next: 'icon icon_chevron-right',
          today: 'icon icon_crosshairs',
          clear: 'icon icon_trash',
          close: 'icon icon_remove',
        },
      },
    };

    const $steps = $('.steps');
    const $pudoLink = $('#no-pudo-locator-link');

    const $location = $('.location');
    $location.data('location', new Location($location, {
      points: this.options.marks,
      zip: this.options.marks_zip,
      country: this.options.country,
      message: this.options.message, // If there are no points then message will be defined
      center: this.options.center, // If points are present then center will be defined
      searchWidgetClass: this.options.search_widget,
      onRefresh: () => {
        $(Courier.ITEM).each((index, element) => {
          const $courier = $(element);
          const data = $courier.data('courier');
          if (data) {
            data.deselect();
          }
        });

        $steps.attr('data-pay', 0);
        this.disabledServices();

        $pudoLink.addClass('hidden');
      },
    }));

    const $error = $('#error_msg');
    const $couriers = $(Courier.ITEM);

    if ($couriers.length === 0) {
      $('.services-list').hide();
    }

    const self = this;
    this.initHomeCollection();

    const $locationList = $('.location__list');
    $couriers.not('.shipping__courier_button').each((index, element) => {
      const $courier = $(element);
      $courier.data('courier', new Courier($courier));

      const maintenance = this.options.carriers_maintenance[$courier.data('carrier')];
      if (maintenance) {
        $courier.data('courier').disable();
        tippy($courier.find('.courier__state')[0], {
          content: maintenance,
          allowHTML: true,
        });
      }
    }).on('change', function courierChange() {
      $error.hide();

      const serviceId = $(this).data('service');
      const carrierId = $(this).data('carrier');
      const externalPudoLocatorUrl = $(this).data('locator');

      // detaching offices increases performance
      const $offices = $(Office.ITEM).detach();
      const selector = `[data-service="${serviceId}"][data-carrier="${carrierId}"]`;
      const $officesWithSelector = $offices.filter(selector);
      $officesWithSelector.each((index, element) => {
        const data = $(element).data('office');
        if (data) {
          // Office methods don't work for detached elements (why?), so we should control
          // visibility manually
          // data.show();
          $(element).show();
          data.marker.setVisible(true);
        }
      });

      $('#js-map').parent().toggleClass('hidden', !$officesWithSelector.length);
      $('#no-pudo-message').toggleClass('hidden', !!$officesWithSelector.length);
      $pudoLink.toggleClass('hidden', !externalPudoLocatorUrl).attr('href', externalPudoLocatorUrl || '#');

      $offices.not(selector).each((index, element) => {
        const data = $(element).data('office');
        if (data) {
          // see comment above
          // data.hide();
          data.deselect();
          $(element).hide();
          data.marker.setVisible(false);
        }
      });
      // return offices to the DOM
      $locationList.append($offices);
      // refresh clusters
      $location.data('location').markerCluster.repaint();

      if ($(this).find(':radio').data('free')) {
        $steps.attr('data-pay', 0);
      } else {
        $steps.attr('data-pay', 1);
      }

      const $additionalFields = $('.js-additional-fields');
      $additionalFields.filter(`[data-carrier="${carrierId}"]`).each((index, element) => {
        const $fields = $(element);
        const fieldsServiceId = $fields.data('service');
        const showFields = fieldsServiceId === undefined || fieldsServiceId === serviceId;
        $fields.toggleClass('hidden', !showFields).find('input, select').prop('disabled', !showFields);
      });
      $additionalFields.not(`[data-carrier="${carrierId}"]`).addClass('hidden').find('input, select').prop('disabled', true);

      self.selectedServiceName = $(this).data('home-collection');
      self.timeSlotsByService = self.collectionDates[self.selectedServiceName];
      self.showHomeCollectionBlock(!!$(this).data('slots-required'));
      self.updateDateSlotsByCarrier();
    }).filter(':has(:checked)')
      .trigger('change', [{ initial: true }]);

    this.disabledServices();

    const $activeCouriers = $couriers.not(`.${Courier.ITEM_DISABLED}`);
    if ($activeCouriers.length === 1) {
      $activeCouriers.data('courier').select();
      $activeCouriers.trigger('change', [{ initial: true }]);
    }

    const shippingFormAPI = $('.shipping-form').validate({
      invalidHandler(event, validator, msg) {
        if (msg) {
          $error.html(msg).show();
        } else {
          $error.hide();
        }
      },

      errorPlacement(error, element) {
        if (element.is(':radio')) {
          $error.text(error.text()).show();
        } else {
          element.after(error);
        }
      },

      submitHandler(form) {
        if (self.areSlotsMissing) {
          return;
        }

        const settings = {
          api: shippingFormAPI,
        };
        const debugSettings = {
          page: 'shipping',
        };

        $(form).ajaxSubmit(ajaxSettings(settings, debugSettings));
      },
    });
  }

  disabledServices() {
    $(Courier.ITEM).not('.shipping__courier_button').each((index, element) => {
      const $courier = $(element);
      const carrierId = $courier.data('carrier');

      if (this.options.carriers_maintenance[carrierId]) {
        return;
      }

      if ($courier.data('home-collection')) {
        return;
      }

      const $offices = $(Office.ITEM);
      const selector = `[data-service="${$courier.data('service')}"]`;
      const count = $offices.filter(selector).length;
      const state = $courier.find('.courier__state');
      // eslint-disable-next-line no-underscore-dangle
      const tippyInstance = state[0]._tippy;

      if (this.options.carrier_drop_off[carrierId] && count === 0) {
        $courier.data('courier').disable();

        if (tippyInstance) {
          tippyInstance.enable();
        } else {
          tippy(state[0], {
            content: this.options.disabled_service_msg,
          });
        }
      } else {
        $courier.data('courier').enable();

        if (tippyInstance) {
          tippyInstance.disable();
        }
      }
    });
  }

  initHomeCollection() {
    this.addMomentToCollectionDates();

    this.selectedServiceName = null;
    this.timeSlotsByService = null;
    this.areSlotsMissing = null;

    const $homeCollectionSettings = $('#home_collection_settings');
    this.$homeCollection = {
      block: $homeCollectionSettings,
      form: $homeCollectionSettings.find('.js-time-form'),
      date: $homeCollectionSettings.find('.js-date'),
      time: $homeCollectionSettings.find('.js-time'),
      timeFrom: $homeCollectionSettings.find('.js-time-from'),
      timeTo: $homeCollectionSettings.find('.js-time-to'),
      selectBtn: $homeCollectionSettings.find('.js-select-time'),
      resetBtn: $homeCollectionSettings.find('.js-reset-time'),
      alert: $homeCollectionSettings.find('.js-homecollection-error'),
    };

    this.$homeCollection.date.datetimepicker({
      useCurrent: false,
      format: 'DD-MM-YYYY',
      focusOnShow: false,
    }).on('dp.change', this.updateTimeSlotsByDate.bind(this));

    this.$homeCollection.picker = this.$homeCollection.date.data('DateTimePicker');

    this.bindHomeCollectionEvents();
  }

  addMomentToCollectionDates() {
    /**
     * @type {Record<string, { date: string, time_from: string, time_to: string, dateMoment: Moment }[]>}
     */
    this.collectionDates = Object.entries(this.options.collection_dates)
      .reduce((acc, [name, slots]) => ({
        ...acc,
        [name]: slots.map((slot) => ({
          ...slot,
          dateMoment: moment(slot.date, 'YYYY-MM-DD'),
        })),
      }), {});
  }

  updateTimeSlotsByDate() {
    if (this.selectedServiceName && this.timeSlotsByService) {
      /**
       * @type {{ date: string, time_from: string, time_to: string, dateMoment: Moment }[]}
       */
      const timeSlotsByDate = this.timeSlotsByService.filter((slot) => {
        const selectedDate = this.$homeCollection.picker.date();
        return selectedDate && slot.date === selectedDate.format('YYYY-MM-DD');
      });

      this.$homeCollection.time
        .empty()
        .append(() => {
          let set = $();

          timeSlotsByDate.forEach((slot) => {
            set = set.add(`<option data-from='${slot.time_from}' data-to='${slot.time_to}'>
            ${slot.time_from}-${slot.time_to}
          </option>`);
          });

          return set;
        })
        .trigger('change');
    }
  }

  updateDateSlotsByCarrier() {
    if (this.selectedServiceName && this.timeSlotsByService) {
      const firstTimeSlot = this.timeSlotsByService[0];
      const lastTimeSlot = this.timeSlotsByService[this.timeSlotsByService.length - 1];

      this.$homeCollection.picker.minDate(firstTimeSlot.dateMoment);
      this.$homeCollection.picker.maxDate(lastTimeSlot.dateMoment);
      this.$homeCollection.picker.defaultDate(firstTimeSlot.dateMoment);
      this.$homeCollection.picker.enabledDates(
        this.timeSlotsByService.map(({ dateMoment }) => dateMoment),
      );
    }
  }

  bindHomeCollectionEvents() {
    const showOptionalForm = (show = false) => {
      this.$homeCollection.form.toggleClass('hidden', !show);
      this.$homeCollection.selectBtn.toggleClass('hidden', show);
      this.$homeCollection.resetBtn.toggleClass('hidden', !show);
      this.$homeCollection.block.find('input, select').prop('disabled', !show);
    };

    this.$homeCollection.time.on('change', () => {
      const selectedOption = this.$homeCollection.time.find(':selected');
      this.$homeCollection.timeFrom.val(selectedOption.data('from'));
      this.$homeCollection.timeTo.val(selectedOption.data('to'));
    });

    this.$homeCollection.selectBtn.on('click', () => { showOptionalForm(true); });
    this.$homeCollection.resetBtn.on('click', () => { showOptionalForm(false); });
  }

  showHomeCollectionBlock(areSlotsRequired = false) {
    this.areSlotsMissing = this.selectedServiceName && !this.timeSlotsByService
      && areSlotsRequired;
    const shouldShowBlock = (this.selectedServiceName && this.timeSlotsByService)
      || this.areSlotsMissing;
    const shouldShowForm = this.selectedServiceName && this.timeSlotsByService && areSlotsRequired;
    const shouldShowSelect = this.selectedServiceName
      && this.timeSlotsByService
      && !areSlotsRequired;

    this.$homeCollection.block.toggleClass('hidden', !shouldShowBlock)
      .find('input, select')
      .prop('disabled', !shouldShowForm)
      .prop('required', areSlotsRequired);
    this.$homeCollection.form.toggleClass('hidden', !shouldShowForm);
    this.$homeCollection.selectBtn.toggleClass('hidden', !shouldShowSelect);
    this.$homeCollection.resetBtn.toggleClass('hidden', true);

    this.$homeCollection.alert.toggleClass('hidden', !this.areSlotsMissing);

    this.$homeCollection.picker.clear();
  }
}

window.returns = { ...window.returns };
window.returns.default = { ...window.returns.default, ...{ Shipping } };

export default Shipping;
